import {Component, Input, OnInit} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-help-docs-modal',
    templateUrl: './help-docs-modal.component.html',
    styleUrls: ['./help-docs-modal.component.css'],
    standalone: false
})
export class HelpDocsModalComponent {
  @Input() helpContent: any;
  constructor(public activeModal: NgbActiveModal) { }
}
